module.exports = "/static/assets/b6f3e6955d5623178c95632608fa4961.png";